export const wcconfig = {
  assets: {
    visa:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-ordering-test.appspot.com/o/onlineoredering%2Fassets%2Fvisa.png?alt=media&token=2f71ec68-86a6-425a-9ce3-ef98d38713fc",
    master:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-ordering-test.appspot.com/o/onlineoredering%2Fassets%2Fmaster.png?alt=media&token=52c6e853-5964-4d08-bb6d-f40ab18a852e",
    introHead:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-ordering-test.appspot.com/o/onlineoredering%2Fassets%2Fresturant-list.jpg?alt=media&token=02fad3b8-07f7-4cad-92b3-4cb6474ff2fe",
    head:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-ordering-test.appspot.com/o/onlineoredering%2Fassets%2Fhead.jpg?alt=media&token=823f0651-d83e-472a-8c65-fb65422bd996",
    favicon:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-ordering-test.appspot.com/o/onlineoredering%2Fassets%2Ffavicon.ico?alt=media&token=1e9537ba-4f2a-4fb0-ba80-129d84c14598",
    abacus:
      "https://firebasestorage.googleapis.com/v0/b/abacus-online-ordering-test.appspot.com/o/onlineoredering%2Fassets%2Fapp.abacus.co-logo.png?alt=media&token=bf48b902-db36-4d5d-b4a9-344002a02139"
  }
};
